import React, { useEffect } from "react";
import M from "materialize-css";
import BotonRegresar from "./shared/BotonRegresar";

const fotos = [
  // { archivo: "foto1.jpg", texto: "Acompañamiento a familias en hospitales" },
  // { archivo: "foto2.jpg", texto: "Spidey en acción con los niños" },
  // { archivo: "foto3.jpg", texto: "Taller de expresión creativa" },
  // { archivo: "foto4.jpg", texto: "Charlas educativas para padres" },
  // { archivo: "foto5.jpg", texto: "Pintura y emociones en familia" },
  // { archivo: "foto6.jpg", texto: "Enseñando" },
  { archivo: "informate1.jpg", texto: "sss" },
  { archivo: "informate2.jpg", texto: "" },
  { archivo: "informate3.jpg", texto: "" },
  { archivo: "informate4.jpeg", texto: "" },
  { archivo: "informate5.jpeg", texto: "" },
  { archivo: "informate6.jpeg", texto: "" },
  { archivo: "informate7.jpeg", texto: "" },
  { archivo: "informate8.jpeg", texto: "" },
  { archivo: "informate9.jpeg", texto: "" },
  { archivo: "informate10.jpeg", texto: "" },
  { archivo: "foto10.jpg", texto: "" },
{ archivo: "foto11.jpg", texto: "" },
{ archivo: "foto12.jpg", texto: "" },
{ archivo: "foto13.jpg", texto: "" },
{ archivo: "foto15.jpg", texto: "" },
{ archivo: "foto16.jpg", texto: "" },
{ archivo: "foto17.jpg", texto: "" },
{ archivo: "foto18.jpg", texto: "" },
{ archivo: "foto19.jpg", texto: "" },
{ archivo: "foto20.jpg", texto: "" },
{ archivo: "foto21.jpg", texto: "" },
{ archivo: "foto24.jpg", texto: "" },
{ archivo: "foto25.jpg", texto: "" },
{ archivo: "foto26.jpg", texto: "" },
{ archivo: "foto27.jpg", texto: "" },
{ archivo: "foto28.jpg", texto: "" },
{ archivo: "foto29.jpg", texto: "" },
{ archivo: "foto30.jpg", texto: "" },
{ archivo: "foto31.jpg", texto: "" },
{ archivo: "foto32.jpg", texto: "" },
{ archivo: "foto33.jpg", texto: "" },
{ archivo: "foto34.jpg", texto: "" },
{ archivo: "foto35.jpg", texto: "" },
{ archivo: "foto36.jpg", texto: "" },
{ archivo: "foto41.jpg", texto: "" },
{ archivo: "foto43.jpg", texto: "" },
{ archivo: "foto44.jpg", texto: "" },
{ archivo: "foto45.jpg", texto: "" },
{ archivo: "foto46.jpg", texto: "" },
{ archivo: "foto48.jpg", texto: "" },
{ archivo: "foto50.jpg", texto: "" },
{ archivo: "foto51.jpg", texto: "" },
{ archivo: "foto52.jpg", texto: "" },
{ archivo: "foto54.jpg", texto: "" },
{ archivo: "foto56.jpg", texto: "" },
{ archivo: "foto57.jpg", texto: "" },
{ archivo: "foto58.jpg", texto: "" },
{ archivo: "foto59.jpg", texto: "" },
{ archivo: "foto61.jpg", texto: "" },
{ archivo: "foto62.jpg", texto: "" },
{ archivo: "foto63.jpg", texto: "" },
{ archivo: "foto66.jpg", texto: "" },
{ archivo: "foto68.jpg", texto: "" },
{ archivo: "foto69.jpg", texto: "" },
{ archivo: "foto70.jpg", texto: "" },
{ archivo: "foto71.jpg", texto: "" },
{ archivo: "foto73.jpg", texto: "" },
{ archivo: "foto74.jpg", texto: "" },
{ archivo: "foto75.jpg", texto: "" },
{ archivo: "foto77.jpg", texto: "" },
{ archivo: "foto80.jpg", texto: "" },
{ archivo: "foto81.jpg", texto: "" },
{ archivo: "foto83.jpg", texto: "" },
{ archivo: "foto85.jpg", texto: "" },
{ archivo: "foto86.jpg", texto: "" },

];

const informes = [2025,2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017];

export default function Informate({ onBack }) {
  useEffect(() => {
    const tabs = document.querySelectorAll(".tabs");
    M.Tabs.init(tabs);
  }, []);

  return (
    <div className="container section">

      {/* Panel general */}
      <div
        className="card z-depth-1"
        style={{
          borderRadius: "20px",
          padding: "1rem",
          overflow: "hidden",
        }}
      >
        {/* Pestañas */}
        <ul
          className="tabs tabs-fixed-width pink lighten-4"
          style={{ borderRadius: "20px 20px 0 0" }}
        >
          <li className="tab col s6">
            <a href="#actividades" className="active">
              Actividades
            </a>
          </li>
          <li className="tab col s6">
            <a href="#informes" >Informes Anuales</a>
          </li>
        </ul>

        {/* Sección Actividades */}
        <div
          id="actividades"
          className="row"
          style={{ padding: "2rem", }}
        >
          <h5 className="center black-text text-darken-1">Actividades</h5>
          <p className="center-align black-text">
            Un vistazo a nuestras memorias en acción.
          </p>

          {fotos.map((foto, idx) => (
            <div key={idx} className="col s12 m6 l4">
              <div
                className="card hoverable z-depth-1"
                style={{ borderRadius: "16px" }}
              >
                <div className="card-image">
                 <img
  src={`/assets/images/informate/${foto.archivo}`}
  alt={`actividad-${idx}`}
  className="responsive-img"
  style={{
    borderRadius: "16px 16px 0 0",
    padding: "1vh",
    height: "500px",         // <-- Tamaño uniforme
    objectFit: "cover",      // <-- Recorta proporcionalmente para que no se deforme
    width: "100%",           // Asegura que llene el contenedor
  }}
/>

                </div>
                {/* <div className="card-content center-align">
                  <p
                    className="grey-text text-darken-2"
                    style={{ fontStyle: "italic" }}
                  >
                    {foto.texto}
                  </p>
                </div> */}
              </div>
            </div>
          ))}
        </div>

        {/* Sección Informes */}
        <div id="informes" className="row" style={{ padding: "2rem" }}>
          <h5 className="center black-text text-darken-1">Informes Anuales</h5>
          <p className="center-align black-text">
            Descarga nuestros informes en formato PDF.
          </p>

          {informes.map((year, idx) => (
            <div key={idx} className="col s12 m6 l4">
              <div
                className="card hoverable z-depth-1 pink lighten-5 center-align"
                style={{ borderRadius: "14px" }}
              >
                <div className="card-content">
                  <i
                    className="material-icons pink-text"
                    style={{ fontSize: "48px" }}
                  >
                    picture_as_pdf
                  </i>
                  <h6 className="black-text text-darken-2">Informe {year}</h6>
                  <a
                    href={`/assets/docs/informe${year}.pdf`}
                    className="btn-flat pink-text text-darken-1 waves-effect"
                    download
                  >
                    Descargar{" "}
                    <i className="material-icons right">file_download</i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
              <BotonRegresar onClick={onBack} />

      </div>
    </div>
  );
}
